export const passwordValidation = () => {
  return new RegExp(
    /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{10,}$/
  );
};
